// Constants as in the backend. Is used to set the project mode
export const IMAGE_MODE = Object.freeze({
	GENERATE_ORTHOPHOTO: 'generate_orthophoto',
	UPLOAD_ORTHOPHOTO: 'upload_orthophoto',
	SINGLE_IMAGE: 'single_image',
});

// Constants as in the frontend for the project mode
export const PROJECT_MODE = Object.freeze({
	ORTHOPHOTO: 'orthophoto',
	SINGLE_IMAGE: 'single_image',
});

// Constants for the model mode
export const MODEL_TYPE = Object.freeze({
	OBJECT_DETECTION: 'object_detection',
	SEGMENTATION: 'segmentation',
});

// Constants for the coordinate system
export const COORDINATE_SYSTEM = Object.freeze({
	PIXEL: 'pixel',
	EPSG_3857: 'EPSG:3857',
});

export const MAP_LAYER_NAMES = Object.freeze({
	orthophoto: 'Aerial Map',
	canopy_height: 'Height Model',
	colored_chm: 'Height Classes',
	national_dtm: 'Terrain',
	contours: 'Contours',
	raw_images: 'Drone Images',
});

// Org products that can be toggled on/off (mirrors the backend ProductEnum).
// Each product enables a set of entitlements server-side when turned on.
// `value` is the ProductEnum sent in the API path; `label` is for display.
// `isDefault` marks products that are part of every org's baseline set and so
// are not shown as toggles in the admin UI.
export const PRODUCTS = Object.freeze([
	{ value: 'product.portal', label: 'Portal', isDefault: true },
	{ value: 'product.training', label: 'Training', isDefault: true },
	{ value: 'product.dsp', label: 'DSP' },
	{ value: 'product.wms', label: 'WMS' },
	{ value: 'product.flightplanner', label: 'Flight Planner' },
	{ value: 'product.video', label: 'Video' },
	{ value: 'product.hip', label: 'HIP' },
]);
